import { useMemo } from 'react';
import { CustomButtonFields, CustomContent, FieldOptionsWithRouter } from '../types';
import {
  getComplexContentObject,
  getContentBlockField,
  getPlaceholderForPreview,
  shouldShowContentBlockPlaceholders
} from '../utils';

export const useContentBlockButton = (
  customContent: CustomContent[],
  { slug, router }: FieldOptionsWithRouter
): CustomButtonFields | null =>
  useMemo(() => {
    const rawContent = getContentBlockField(customContent, 'custom-button', { slug });
    const content = getComplexContentObject<CustomButtonFields>(rawContent);
    if (!content || !content.label || !content.link) {
      return shouldShowContentBlockPlaceholders(router)
        ? ({
            label: content?.label || getPlaceholderForPreview(router, 'Button', ''),
            link: content?.link || getPlaceholderForPreview(router, '#', '')
          } satisfies CustomButtonFields)
        : null;
    }
    return {
      label: content.label,
      link: content.link
    } satisfies CustomButtonFields;
  }, [customContent, router, slug]);
